import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import HermesChat from '@/components/platform-admin/HermesChat';
import { ArrowLeft } from 'lucide-react';

const HermesChatPage = () => {
  return (
    <div className="min-h-screen bg-background admin-theme">
      {/* Header */}
      <header className="sticky top-0 z-30 border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button variant="ghost" size="sm" asChild>
              <Link to="/platform-admin">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Dashboard
              </Link>
            </Button>
            <h1 className="text-lg font-bold heading-font">Hermes Platform Agent</h1>
            <div className="w-24" /> {/* Spacer for centering */}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-8">
        <div className="h-[calc(100vh-200px)] max-w-5xl mx-auto">
          <HermesChat />
        </div>
      </main>
    </div>
  );
};

export default HermesChatPage;
